import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiListOl, BiRefresh, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const SummaryList = () => {
    const [selectedData, setselectedData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [listSummaryList, setListSummaryList] = useState([]);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true)

        try {
            const promise1 = await VedikaService.getSummaryList($('#noRegistrasi').text());
            const allPromise = await Promise.all([promise1]);
            setListSummaryList(allPromise[0].data.data)
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }
    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        setselectedData(row)
    }

    const loadDTSummaryList = () => {
        $('#dtSummaryList').DataTable({
            data: listSummaryList,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    width:'5%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Detail' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup></div>),
                },
                {
                    targets: [1],
                    data: 'nama_ruangan',
                    width:'15%',
                },
                {
                    targets: [2],
                    data: 'diagnosa',
                    width:'15%',
                    render: function (data, type) {
                        let result = '';
                        if (data.length == 0) {
                            result = '-'
                        }
                        data.forEach((e,index) => {
                            result += `<span>${index+1}.</span>&nbsp;${e.kddiagnosa} - ${e.namadiagnosa}<br/>`;
                        });
                        return result;
                    }
                },
                {
                    targets: [3],
                    data: 'obat',
                    width:'15%',
                    render: function (data, type) {
                        let result = '';
                        if (data.length == 0) {
                            result = '-'
                        }
                        data.forEach((e,index) => {
                            result += `<span>${index+1}.</span>&nbsp;${e.namaproduk}<br/>`;
                        });

                        return result;
                    }
                },
                {
                    targets: [4],
                    data: 'tindakan',
                    width:'15%',
                    render: function (data, type) {
                        let result = '';
                        if (data.length == 0) {
                            result = '-'
                        }
                        data.forEach((e,index) => {
                            result += `<span>${index+1}.</span>&nbsp;${e.namaproduk}<br/>`;
                        });

                        return result;
                    }
                },
                {
                    targets: [5],
                    data: 'soap',
                    width:'15%',
                    render: function (data, type) {
                        let result = '';
                        if (data.length == 0) {
                            result = '-'
                        }
                        data.forEach(e => {
                            // result += `<span style="font-weight:600">A :</span> ${e.assestment ? e.assestment : ''}<br/>`;
                            result += `<span style="font-weight:600">P :</span> ${e.planning ? e.planning : ''}<br/>`;
                        });

                        return result;
                    }
                },
                {
                    targets: [6],
                    data: 'nama_dokter_dpjp',
                    width:'20%',
                },
            ]
        })
    }

    useEffect(()=>{
        loadDTSummaryList();
    },[listSummaryList])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Summary List</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/summarylist/${$('#norec').val()}`} style={{ textDecoration: 'none', color: 'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtSummaryList' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Unit/Klinik</th>
                                <th>Diagnosa</th>
                                <th>Obat Yang Diresepkan</th>
                                <th>Tindakan</th>
                                <th>Catatan Medis</th>
                                <th>Dokter</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col md={6}>
                                    <p className='f7'><strong>Dokter</strong><br />{selectedData ? selectedData.nama_dokter_dpjp : ''}</p>
                                </Col>
                                <Col md={6}>
                                    <p className='f7'><strong>Unit/Klinik</strong><br />{selectedData ? selectedData.nama_ruangan : ''}</p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className='mt-2'>
                        <Card.Header>
                            <h5>Detail</h5>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col sm={12}>
                                    <p className='f7'><strong>Tindakan</strong><br />{
                                        selectedData ?
                                            selectedData.tindakan.map((tindakan) => (
                                                <>
                                                    {tindakan.namaproduk}<br />
                                                </>
                                            )) : null
                                    }</p>
                                </Col>
                                <Col sm={12}>
                                    <hr className="hr" /><p className='f7'><strong>Diagnosis</strong><br />{
                                        selectedData ?
                                            selectedData.diagnosa.map((diagnosa) => (
                                                <>
                                                    <span>{diagnosa.kddiagnosa} - {diagnosa.namadiagnosa}</span><br />
                                                </>
                                            )) : null
                                    }</p>
                                </Col>
                                <Col sm={12}>
                                    <hr className="hr" /><p className='f7'><strong>Obat yang diresepkan</strong><br />{
                                        selectedData ?
                                            selectedData.obat.map((obat) => (
                                                <>
                                                    {obat.namaproduk}<br />
                                                </>
                                            )) : null
                                    }</p>
                                </Col>
                                <Col sm={12}>
                                    <hr className="hr" /><p className='f7'><strong>Catatan Medis</strong><br />{
                                        selectedData ?
                                            selectedData.soap.map((soap) => (
                                                <>
                                                    <span style={{ fontWeight: 600 }}>A :</span> {soap.assestment}<br />
                                                    <span style={{ fontWeight: 600 }}>P :</span> {soap.planning}<br />
                                                </>
                                            )) : null
                                    }</p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default SummaryList;